/* eslint-disable prettier/prettier */
export { getFromStoretextCustom, isFeatureEnabledFromStoretextCustom } from './storetext-custom'
